import {ScriptSource} from "./ScriptSource";
import {ScriptReference} from "./ScriptReference";
import {isModuleSource} from "./ModuleSource";
import {isClassicSource} from "./ClassicSource";

// prettier-ignore
export interface ScriptDefinition
    extends ScriptReference {
  source: ScriptSource;
  async?: boolean;
  defer?: boolean;
}

/**
 * A type guard for testing that an object is assignable to the {@link ScriptDefinition}
 * type.
 *
 * @param argument
 */
export const isScriptDefinition = (
  argument: any
): argument is ScriptDefinition => {
  // prettier-ignore
  return typeof argument === "object"
      && argument !== null
      && "id" in argument
      && typeof argument.id === "string"
      && "source" in argument
      && typeof argument.source === "object"
      && argument.source !== null
      && (isModuleSource(argument.source) || isClassicSource(argument.source))
      && (argument.async === undefined || typeof argument.async === "boolean")
      && (argument.defer === undefined || typeof argument.defer === "boolean")
      && (argument.code === undefined || typeof argument.code === "string");
};
